import React, { useState } from 'react';
import { TableCell, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { styled } from '@mui/material/styles';
import { formatMoney, dateToString } from '../../shared/formatters';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: 'rgba(0, 98, 105, 0.04)',
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontSize: '0.938rem',
    fontWeight: 500,
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    position: 'sticky',
    left: 0,
    backgroundColor: 'white',
    zIndex: 2,
}));

const MoneyCell = styled(TableCell)(({ theme }) => ({
    fontSize: '0.938rem',
    fontWeight: 500,
    padding: '16px',
    whiteSpace: 'nowrap',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
}));

const GroupCell = styled(TableCell)(({ theme }) => ({
    cursor: 'pointer',
    fontWeight: 700,
    fontSize: '0.938rem',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    position: 'sticky',
    left: 0,
    backgroundColor: 'white',
    zIndex: 2,
}));

function showTransactions(date, categoryId, updateTransactionFilters, navigate) {
    var dateSplit = date.split('/');
    if (!!date[1]) {
        var month = parseInt(dateSplit[0]) - 1;
        var year = parseInt(dateSplit[1]);
        const searchFilters = {
            description: '',
            categories: [categoryId],
            groups: [],
            financeAccounts: [],
            users: [],
            from: dateToString(new Date(year, month, 1)),
            to: dateToString(new Date(year, month + 1, 0))
        };
        updateTransactionFilters(searchFilters);
        navigate('/transactions');
    }
}

function showGroupTransactions(date, groupData, categoryData, updateTransactionFilters, navigate) {
    var dateSplit = date.split('/');
    if (!!date[1]) {
        var month = parseInt(dateSplit[0]) - 1;
        var year = parseInt(dateSplit[1]);
        
        let categoryIds = [];
        let groupIds = [];
        
        // Check if this is a creditId or debitId (special groups with no actual categories)
        if (groupData.group.id === 'creditId' || groupData.group.id === 'debitId') {
            // For credit/debit groups, get all categories that don't belong to any group
            // and match the type (credit or debit)
            if (categoryData && categoryData.length > 0) {
                const categoryType = groupData.group.id === 'creditId' ? 'credit' : 'debit';
                categoryIds = categoryData
                    .filter(cat => !cat.group && (cat.type === categoryType))
                    .filter(cat => cat.type !== 'credit-transfer' && cat.type !== 'debit-transfer')
                    .map(cat => cat.id);
            }
            // Don't set groupIds, keep it empty
            groupIds = [];
        } else {
            // For regular groups, get all category IDs belonging to this group
            categoryIds = Object.keys(groupData.categories).map(
                categoryKey => groupData.categories[categoryKey].category.id
            );
            
            // Add categories that don't have a group (if available in categoryData)
            if (categoryData && categoryData.length > 0) {
                const ungroupedCategoryIds = categoryData
                    .filter(cat => !cat.group)
                    .filter(cat => cat.type !== 'credit-transfer' && cat.type !== 'debit-transfer')
                    .map(cat => cat.id);
                categoryIds.push(...ungroupedCategoryIds);
            }
            
            groupIds = [groupData.group.id];
        }
        
        const searchFilters = {
            description: '',
            categories: categoryIds,
            groups: groupIds,
            financeAccounts: [],
            users: [],
            from: dateToString(new Date(year, month, 1)),
            to: dateToString(new Date(year, month + 1, 0))
        };
        updateTransactionFilters(searchFilters);
        navigate('/transactions');
    }
}

const GroupComponent = ({groupData, months, updateTransactionFilters, navigate, categoryData}) => {
    const categories = Object.keys(groupData.categories);
    const [open, setOpen] = useState(false);
    const handleToggle = () => {
        setOpen(!open);
    };

    
    return <React.Fragment key={groupData.group.id}>
        <StyledTableRow hover>
            <GroupCell component="th" scope="row" onClick={handleToggle}>
                {groupData.group.name}
                {open ? (
                    <RemoveIcon sx={{ fontSize: '1rem', ml: 1, verticalAlign: 'middle' }} />
                ) : (
                    <AddIcon sx={{ fontSize: '1rem', ml: 1, verticalAlign: 'middle' }} />
                )}
            </GroupCell>
            {(months || []).map(month => <MoneyCell 
                key={month} 
                align="right" 
                sx={{ fontWeight: 700 }}
                onClick={() => showGroupTransactions(
                    month,
                    groupData,
                    categoryData,
                    updateTransactionFilters,
                    navigate)}>
                {formatMoney(groupData.balance[month])}
            </MoneyCell>)}
        </StyledTableRow>
        {open && (categories || []).map(categoryKey => <StyledTableRow key={categoryKey} hover>
            <StyledTableCell scope="row">
                {groupData.categories[categoryKey].category.name}
            </StyledTableCell>
            {(months || []).map(month => <MoneyCell
                key={month}
                align="right"
                onClick={() => showTransactions(
                    month,
                    groupData.categories[categoryKey].category.id,
                    updateTransactionFilters,
                    navigate)}            >
                {formatMoney(groupData.categories[categoryKey].balance[month])}
            </MoneyCell>)}
        </StyledTableRow>)}
    </React.Fragment>;
}

export default GroupComponent;
